import React from 'react';
import { Card, CardContent } from '@/components/ui';

export interface SafetyStats {
  incidents: number;
  accidents: number;
  inspections: number;
  compliance: number;
}

interface SafetyMetricsProps {
  stats?: SafetyStats;
  isLoading?: boolean;
}

export function SafetyMetrics({ stats: data, isLoading }: SafetyMetricsProps) {
  const stats = data || {
    incidents: 0,
    accidents: 0,
    inspections: 10,
    compliance: 100
  };

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-sm font-bold text-slate-800">An toàn lao động</h3>
          <button className="text-[10px] font-bold text-emerald-600 hover:underline">Xem chi tiết</button>
        </div>

        <p className="text-[11px] font-medium text-slate-400 text-center mb-8">
          Không có sự cố an toàn trong 30 ngày qua
        </p>

        <div className="flex justify-between items-end flex-1">
          <SafetyStatItem 
            icon="ri-survey-line" 
            label="Sự cố" 
            value={stats.incidents} 
            color="text-emerald-600" 
            bg="bg-emerald-50" 
          />
          <SafetyStatItem 
            icon="ri-heart-pulse-line" 
            label="Tai nạn" 
            value={stats.accidents} 
            color="text-orange-500" 
            bg="bg-orange-50" 
          />
          <SafetyStatItem 
            icon="ri-shield-check-line" 
            label="Kiểm tra" 
            value={stats.inspections} 
            color="text-emerald-600" 
            bg="bg-emerald-50" 
          />
          <SafetyStatItem 
            icon="ri-checkbox-circle-line" 
            label="Tuân thủ" 
            value={`${stats.compliance}%`} 
            color="text-emerald-600" 
            bg="bg-emerald-50" 
          />
        </div>
      </CardContent>
    </Card>
  );
}

function SafetyStatItem({ icon, label, value, color, bg }: { icon: string, label: string, value: string | number, color: string, bg: string }) {
  return (
    <div className="flex flex-col items-center gap-2">
      <div className={`w-9 h-9 rounded-xl ${bg} flex items-center justify-center`}>
        <i className={`${icon} ${color} text-lg`} />
      </div>
      <div className="text-center">
        <p className="text-sm font-black text-slate-800 leading-none mb-1">{value}</p>
        <p className="text-[9px] font-bold text-slate-400 uppercase tracking-tighter">{label}</p>
      </div>
    </div>
  );
}
